(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ev-category-menu"] && !Shopify.designMode) return;
  try {
    (()=>{
  function setup(){
    document.querySelectorAll('[data-ev-browse]').forEach(dialog=>{
      if(dialog.dataset.ready)return;
      dialog.dataset.ready='true';
      const trigger=document.querySelector('[data-ev-browse-open="'+dialog.id+'"]');
      if(!trigger)return;
      const groups=[...dialog.querySelectorAll('.ev-browse-category')];
      const desktop=window.matchMedia('(min-width:900px)');
      const categories=dialog.querySelector('.ev-browse-categories');
      function fitPanel(){
        if(!desktop.matches){categories.style.minHeight='';return}
        const panel=dialog.querySelector('.ev-browse-category[open] .ev-browse-category-content');
        const rowHeight=groups.reduce((height,group)=>height+group.querySelector('summary').getBoundingClientRect().height+1,0);
        categories.style.minHeight=Math.ceil(Math.max(432,rowHeight,panel?panel.getBoundingClientRect().height:0))+'px';
      }
      const panelObserver=new ResizeObserver(fitPanel);
      dialog.querySelectorAll('.ev-browse-category-content').forEach(panel=>panelObserver.observe(panel));
      let previousOverflow='';
      function open(){
        if(dialog.open)return;
        previousOverflow=document.body.style.overflow;
        document.body.style.overflow='hidden';
        if(desktop.matches&&!groups.some(group=>group.open)&&groups[0])groups[0].open=true;
        trigger.setAttribute('aria-expanded','true');
        dialog.showModal();
        fitPanel();
      }
      function close(){if(dialog.open)dialog.close()}
      trigger.addEventListener('click',open);
      dialog.addEventListener('close',()=>{
        document.body.style.overflow=previousOverflow;
        trigger.setAttribute('aria-expanded','false');
      });
      dialog.addEventListener('click',event=>{
        if(event.target.closest('[data-ev-browse-close]')||event.target.closest('a')){close();return}
        if(event.target===dialog){
          const box=dialog.getBoundingClientRect();
          if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)close();
        }
      });
      groups.forEach(group=>{
        group.querySelector('summary').addEventListener('click',event=>{
          if(desktop.matches&&group.open)event.preventDefault();
        });
        group.addEventListener('toggle',()=>{
          if(group.open)groups.forEach(other=>{if(other!==group)other.open=false});
          fitPanel();
        });
      });
      const resize=()=>{if(dialog.open&&desktop.matches&&!groups.some(group=>group.open)&&groups[0])groups[0].open=true;fitPanel()};
      desktop.addEventListener('change',resize);
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target.contains(dialog)){close();desktop.removeEventListener('change',resize);panelObserver.disconnect()}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

})();
